import type { PlatformTagUsage } from '@brush/api-client';

/**
 * How many tournaments carry each platform tag, as the server counts them (`GET /api/platform-tags/usage`, known gap
 * 92): every room's tournaments, matched without regard to case. It used to be counted here over `listAll()`, the
 * platform's newest 200 tournaments, which undercounted past 200 with nothing saying so.
 *
 * Null while the count has not arrived. A tag missing from the map has not been counted yet, as a tag just added is
 * until the count is read again, so the panel words "counting" rather than claiming zero.
 */
export function usageByTag(rows: readonly PlatformTagUsage[] | undefined): ReadonlyMap<string, number> | null {
  if (!rows) return null;
  return new Map(rows.map((r) => [r.tag, r.tournaments]));
}

/** The line beside a tag. */
export function usedInLine(count: number | undefined): string {
  if (count === undefined) return 'Counting tournaments…';
  if (count === 0) return 'Used in no tournaments';
  return `Used in ${count} tournament${count === 1 ? '' : 's'}`;
}

/** What the remove dialog says after the tag's name. */
export function removalSentence(count: number | undefined): string {
  if (count === undefined) return 'will be stripped from every tournament carrying it.';
  if (count === 0) return 'is not used by any tournament.';
  return count === 1
    ? 'is used in 1 tournament. Removing it strips the tag from that tournament.'
    : `is used in ${count} tournaments. Removing it strips the tag from those tournaments.`;
}
